var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmojiHappy = function SvgEmojiHappy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 113.75H45.5C18.35 113.75 6.75 102.15 6.75 75V45C6.75 17.85 18.35 6.25 45.5 6.25H75.5C102.65 6.25 114.25 17.85 114.25 45V75C114.25 102.15 102.65 113.75 75.5 113.75ZM45.5 13.75C22.45 13.75 14.25 21.95 14.25 45V75C14.25 98.05 22.45 106.25 45.5 106.25H75.5C98.55 106.25 106.75 98.05 106.75 75V45C106.75 21.95 98.55 13.75 75.5 13.75H45.5Z",
    fill: "#434958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 57.749H78.5C83.05 57.749 86.75 61.449 86.75 65.999C86.75 80.449 75 92.249 60.5 92.249C46 92.249 34.25 80.449 34.25 65.999C34.25 61.449 37.95 57.749 42.5 57.749ZM60.5 84.749C70.85 84.749 79.25 76.349 79.25 65.999C79.25 65.599 78.9 65.249 78.5 65.249H42.5C42.1 65.249 41.75 65.599 41.75 65.999C41.75 76.349 50.15 84.749 60.5 84.749Z",
    fill: "#434958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 47.5021C66.35 47.5021 65.4 47.1521 64.65 46.4021C63.2 44.9521 63.2 42.5521 64.65 41.1021C71.1 34.6521 81.65 34.6521 88.15 41.1021C89.6 42.5521 89.6 44.9521 88.15 46.4021C86.7 47.8521 84.3 47.8521 82.85 46.4021C79.3 42.8521 73.5 42.8521 69.95 46.4021C69.25 47.1521 68.3 47.5021 67.3 47.5021Z",
    fill: "#434958"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7012 47.5021C52.7512 47.5021 51.8012 47.1521 51.0512 46.4021C47.5012 42.8521 41.7012 42.8521 38.1512 46.4021C36.7012 47.8521 34.3012 47.8521 32.8512 46.4021C31.4012 44.9521 31.4012 42.5521 32.8512 41.1021C39.3012 34.6521 49.8512 34.6521 56.3512 41.1021C57.8012 42.5521 57.8012 44.9521 56.3512 46.4021C55.6012 47.1521 54.6512 47.5021 53.7012 47.5021Z",
    fill: "#434958"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmojiHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji-happy.98455fbe.svg";
export { ForwardRef as ReactComponent };